import React, { useMemo } from 'react';

import {
  Typography,
  Container,
  PageHeader,
  CardContent,
  CardHeader,
  Card,
} from '@occc-app/design-system';
import { useUserSelector } from '@occc-app/App/AppContext';
import { getPersonFullName } from '@occc-app/lib/person';
import { User_Role } from '@occc/graphql';

const userRoleLabel: Record<User_Role, string> = {
  [User_Role.Admin]: 'admin',
  [User_Role.AdminReadOnly]: 'admin read only',
  [User_Role.BrandAdmin]: 'brand admin',
  [User_Role.BrandUser]: 'brand',
  [User_Role.CommandCenterUser]: 'command center',
  [User_Role.RcUser]: 'RC',
  [User_Role.RetailerNetworkAdmin]: 'retailer network admin',
  [User_Role.RetailerNetworkUser]: 'retailer network ',
  [User_Role.Sitetech]: 'sitetech',
  [User_Role.SiteAdmin]: 'site admin',
  [User_Role.SiteUser]: 'site',
  [User_Role.Support]: 'support',
  [User_Role.ScanDataAdmin]: 'scan data admin',
  [User_Role.ScanDataUser]: 'scan data user',
};

const UnauthorizedPage: React.FC = () => {
  const user = useUserSelector();
  const userFullName = useMemo(() => getPersonFullName(user?.name), [user?.name]);

  if (!user) {
    return null;
  }
  // TODO: move Container and PageHeader to level up and replace it along with Helmet by Page component
  return (
    <Container variant='md' includesPageHeader>
      <PageHeader title='Page Unavailable' />
      <Card>
        <CardHeader
          title={
            <Typography variant='h6' component='h3'>
              Hello, {userFullName || user.email}!
            </Typography>
          }
        />
        <CardContent>
          <Typography gutterBottom>
            {`Unfortunately the page you are trying to reach is unavailable to ${
              userRoleLabel[user.userRole]
            } users.`}
          </Typography>
          <Typography>
            Please contact your Activate Command Center administrator for further details.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default UnauthorizedPage;
